import { render, staticRenderFns } from "./TrendAnalysis.vue?vue&type=template&id=7b506546&scoped=true&"
import script from "./TrendAnalysis.vue?vue&type=script&lang=js&"
export * from "./TrendAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./TrendAnalysis.vue?vue&type=style&index=0&id=7b506546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b506546",
  null
  
)

export default component.exports